export default class SessionEnrolment {
  constructor(API) {
    this.api = API;
  }
  /*
  {
    customerID: 'validString',
    tenantID: 'validString',
    courseID: 'validString',
    userID: 'validString',
    sessionID: 'validString',
    materialShippingInfo: 'optionalValidString',
    firstName: 'validString',
    lastName: 'validString',
    email: 'validString',
    accessRelease: 'validString',
    accessReleasedOn: 'validString',
    externalID: 'validString',
    createdBy: 'any?',
    updatedBy: 'any?',
    updatedOn: 'any?',
    createdOn: 'any?',
    transactionID: 'any?',
  }
  */
  async createSessionEnrolment(sessionID, enrolmentID, externalID, enrolmentObj) {
    const req = await this.api.newBaseRequest('POST');
    req.path = '/session/' + sessionID + `/enrolment/${enrolmentID}/${externalID}`;
    req.body = enrolmentObj;
    return await req.exec();
  }
  async updateSessionEnrolment(sessionID, enrolmentID, externalID, enrolmentObj) {
    const req = await this.api.newBaseRequest('PUT');
    req.path = '/session/' + sessionID + `/enrolment/${enrolmentID}/${externalID}`;
    req.body = enrolmentObj;
    return await req.exec();
  }
  async deleteSessionEnrolment(sessionID, enrolmentID, externalID) {
    const req = await this.api.newBaseRequest('DELETE');
    req.path = '/session/' + sessionID + `/enrolment/${enrolmentID}/${externalID}`;
    return await req.exec();
  }
  async cancelSessionEnrolment(sessionID, enrolmentID, externalID) {
    const req = await this.api.newBaseRequest('POST');
    req.path = '/session/' + sessionID + `/enrolment/${enrolmentID}/${externalID}/cancel`;
    return await req.exec();
  }
  async getSessionEnrolment(sessionID, enrolmentID, externalID) {
    const req = await this.api.newBaseRequest('GET');
    req.path = '/session/' + sessionID + `/enrolment/${enrolmentID}/${externalID}`;
    return await req.exec();
  }
  async getSessionEnrolmentsBySessionID(sessionID) {
    const req = await this.api.newBaseRequest('GET');
    req.path = '/session/' + sessionID + '/enrolments/';
    return await req.exec();
  }
  async getSessionEnrolmentBySessionIDAndUserID(sessionID, enrolmentID) {
    const req = await this.api.newBaseRequest('GET');
    req.path = '/session/' + sessionID + `/enrolment/${enrolmentID}`;
    return await req.exec();
  }
  async releaseSessionEnrolment(sessionID, enrolmentID, externalID) {
    const req = await this.api.newBaseRequest('POST');
    req.path = '/session/' + sessionID + `/enrolment/${enrolmentID}/${externalID}/release`;
    return await req.exec();
  }
  async checkSessionEnrolmentResults(sessionID, enrolmentID, externalID) {
    const req = await this.api.newBaseRequest('POST');
    req.path = '/session/' + sessionID + `/enrolment/${enrolmentID}/${externalID}/checkResult/`;
    return await req.exec();
  }
  async launchSessionEnrolment(sessionID, enrolmentID, externalID, ssoObj) {
    const req = await this.api.newBaseRequest('POST');
    req.path = '/session/' + sessionID + `/enrolment/${enrolmentID}/${externalID}/launch/`;
    req.body = ssoObj;
    return await req.exec();
  }
  async chargeSessionEnrolment(sessionID, enrolmentID, externalID, chargeObj) {
    const req = await this.api.newBaseRequest('POST');
    req.path = '/session/' + sessionID + `/enrolment/${enrolmentID}/${externalID}/charge`;
    req.body = chargeObj;
    return await req.exec();
  }
}
